<template lang="pug">
.fb-like(
  ref="root"
  :data-href="url"
  data-layout="button"
  data-action="like"
  data-size="small"
  data-show-faces="false"
  data-share="true"
)
</template>

<script>
export default {
  name: "tweet-button",
  props: {
    url: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      default: "ja"
    }
  },
  mounted() {
    FB.XFBML.parse(this.$refs.root);
  }
};
</script>
